
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.75 5.693h-1.5c-1.795 0-3.25 1.791-3.25 4s1.455 4 3.25 4h1.5c.414 0 .75-.413.75-.923V6.616c0-.51-.336-.923-.75-.923zM6 7.54v4.307h-.75c-.966 0-1.75-.963-1.75-2.153l.006-.177C3.579 8.41 4.332 7.54 5.25 7.54H6z"}}),_c('path',{attrs:{"d":"M15.334 2.157l-.756.62C12.26 4.678 9.536 5.693 6.75 5.694c-.414 0-.75.413-.75.922v6.154c0 .51.336.923.75.923 2.786 0 5.51 1.015 7.828 2.917l.756.62c.498.409 1.166-.031 1.166-.768V2.925c0-.738-.668-1.177-1.166-.768zM15 4.636v10.113l-.3-.225c-2.163-1.574-4.602-2.483-7.111-2.65L7.5 11.87V7.515l.089-.003c2.508-.167 4.948-1.076 7.11-2.65L15 4.636zm2.75 2.904c.38 0 .694.347.743.797l.007.125v2.462c0 .51-.336.923-.75.923-.38 0-.694-.348-.743-.798L17 10.924V8.462c0-.51.336-.923.75-.923z"}}),_c('path',{attrs:{"d":"M6.75 11.847c.415 0 .75.414.75.923 0 1.375.457 2.69 1.267 3.638.3.351.312.936.026 1.305-.285.37-.76.384-1.06.033C6.626 16.449 6 14.65 6 12.769c0-.51.336-.923.75-.922z"}})])
          )
        }
      }
    